import React from 'react';

import styles from './styles.module.scss';

interface SemiCircleProgressProps {
  stroke?: string;
  strokeWidth?: number;
  background?: string;
  diameter?: number;
  orientation?: 'up' | 'down';
  direction?: 'left' | 'right';
  showPercentValue?: boolean;
  percentage: number;
  ariaLabel?: string;
}

const SemiCircleProgress: React.FC<SemiCircleProgressProps> = ({
  stroke = '#035e11b0',
  strokeWidth = 20,
  background = '#dae9e9',
  diameter = 200,
  orientation = 'up',
  direction = 'right',
  showPercentValue = false,
  percentage,
  ariaLabel,
}) => {
  const coordinateForCircle = diameter / 2;
  const radius = (diameter - 2 * strokeWidth) / 2;
  const circumference = Math.PI * radius;

  let percentageValue;
  if (percentage > 100) {
    percentageValue = 100;
  } else if (percentage < 0) {
    percentageValue = 0;
  } else {
    percentageValue = percentage;
  }
  const semiCirclePercentage = percentageValue * (circumference / 100);

  let rotation;
  if (orientation === 'down') {
    if (direction === 'left') {
      rotation = 'rotate(180deg) rotateY(180deg)';
    } else {
      rotation = 'rotate(180deg)';
    }
  } else {
    if (direction === 'right') {
      rotation = 'rotateY(180deg)';
    }
  }

  return (
    <div className={styles.semicircle_container}>
      <svg
        width={diameter}
        height={diameter / 2}
        style={{ transform: rotation }}
        tabIndex={0}
        role={'progressbar'}
        aria-valuenow={percentageValue}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-label={ariaLabel}>
        <circle
          cx={coordinateForCircle}
          cy={coordinateForCircle}
          r={radius}
          fill={'none'}
          stroke={background}
          strokeWidth={strokeWidth}
          strokeDasharray={circumference}
          style={{
            strokeDashoffset: circumference,
          }}
        />
        <circle
          cx={coordinateForCircle}
          cy={coordinateForCircle}
          r={radius}
          fill={'none'}
          stroke={stroke}
          strokeWidth={strokeWidth}
          strokeDasharray={circumference}
          style={{
            strokeDashoffset: semiCirclePercentage,
            transition: 'stroke-dashoffset .3s ease 0s, stroke-dasharray .3s ease 0s, stroke .3s',
          }}
        />
      </svg>
      {showPercentValue && (
      <h2
        className={styles.semicircle_percent_value}
        style={{
          bottom: orientation === 'down' ? 'auto' : '0',
        }}
        role="progressbar"
        aria-label={`Progress bar: ${percentage}%`}
      >
        {percentage}%
      </h2>
      )}
    </div>
  );
};

export default SemiCircleProgress;
